import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPutFetcher } from '@/common/api/fetcher'
import {
  GetPromotionKarteConfigsVars,
  GetPromotionKarteHistoryVars,
  PromotionKarteApiPath,
  PromotionKarteConfigsResponse,
  PromotionKarteHistoryResponse,
  UpdatePromotionKarteConfigsResponse,
  UpdatePromotionKarteConfigsVars
} from '@/common/api/params/promotionKarte'

export const usePromotionKarteGetApi = () => {
  return useSWR<
    PromotionKarteConfigsResponse,
    Response,
    [string, GetPromotionKarteConfigsVars]
  >([PromotionKarteApiPath.GET_CONFIGS, {}])
}

export const usePromotionKarteUpdateApi = (
  onSuccess?: (r: UpdatePromotionKarteConfigsResponse) => void
) => {
  return useCallMutation<
    UpdatePromotionKarteConfigsResponse,
    UpdatePromotionKarteConfigsVars
  >(PromotionKarteApiPath.UPDATE_CONFIGS, { onSuccess }, apiPutFetcher)
}

export const usePromotionKarteHistoryApi = () => {
  return useSWR<
    PromotionKarteHistoryResponse,
    Response,
    [string, GetPromotionKarteHistoryVars]
  >([PromotionKarteApiPath.GET_HISTORY, {}])
}
